import "./Overlay.scss";
import React, { forwardRef, useState, useEffect } from "react";

const useCheckMobile = () => {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const _isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        window.navigator.userAgent
      );
    console.log(`check device type: ${_isMobile ? "mobile" : "desktop"}`);
    setIsMobile(_isMobile);
  }, []);
  return isMobile;
};

const Overlay = forwardRef(({ caption, scroll, setIsFanRotating }, ref) => {
  const [firstScroll, setFirstScroll] = useState(false);
  const [isScrollTop, setIsScrollTop] = useState(false);

  const handleScroll = (e) => {
    setFirstScroll(true);
    scroll.current =
      e.target.scrollTop / (e.target.scrollHeight - window.innerHeight);
    setIsFanRotating(scroll.current > 0.2 && scroll.current < 0.4);
    setIsScrollTop(scroll.current > 0);
  };

  return (
    <>
      <div className="velina"></div>
      <div ref={ref} onScroll={handleScroll} className="scroll">
        <div style={{ height: "100vh" }}>
          <div
            className={`dot_center${
              firstScroll ? (isScrollTop ? " fade" : " unfade") : ""
            }`}
          >
            <p>Your 3D Product Experience</p>
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          <div className="dot">
            <h1>Hyper quality from every angle</h1>
            {/* An interactive 3D showroom, for all browser and devices */}
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          <div className="dot">
            <h1>Intuitive explanation of the product and its uses</h1>
            {/* Intuitive explanation of the product and its uses */}
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          <div className="dot">
            <h1>Customizable for every need</h1>
            {/* High quality from every angle, like in real life */}
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          <div className="video_container">
            <video className="video" muted autoPlay loop>
              <source src="assets/metaverso.mp4" type="video/mp4" />
              Your browser does not support HTML video.
            </video>
          </div>
        </div>
        <div style={{ height: "100vh" }}>
          <div className="dot_center_full">
            <div className="center">
              <p>
                An unique and unforgettable product experience for all browser
                and devices
              </p>
            </div>
            <ButtonSlide />
          </div>
        </div>
      </div>
      <div className="fader in" />
      <div
        className={`top_logo${
          firstScroll ? (isScrollTop ? " fade" : " unfade") : ""
        }`}
      >
        <img src="assets/ShowVerse_Black-01.png" alt="" />
      </div>
    </>
  );
});

const ButtonSlide = () => {
  const isMobile = useCheckMobile();

  return (
    <div className="buttonSlideContainer">
      <button onClick={() => window.open("https://www.ala-m.com/")}>
        TRY IT
      </button>
      <button>
        <a href="mailto:info@alam.it">ask for more</a>
      </button>
      {isMobile && (
        <button>
          <a href="tel:+393884229516">Call me</a>
        </button>
      )}
    </div>
  );
};

export default Overlay;
